import domtoimage from 'dom-to-image';
import { timer } from 'rxjs';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { Component, ViewChild,OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import { Config, Platform } from '@ionic/angular';
import { Subject } from "rxjs";
import { EventProvider } from '../../providers/event/event';
import { StatisticsResults } from '../../providers/result/result';
import COLORS from '../../tracker/transistor/lib/colors';
import { TreesCounter } from '../event/event-activity-tabs/event-forest/event-activity';
import { TrophyComponent } from '../../components/trophy/trophy';
import { UserProvider } from '../../providers/user/user';
import { SessionProvider } from '../../providers/session/session';
import { SharingProvider } from '../../providers/sharing/sharing';
import { AdsProvider } from '../../providers/ads/ads';
import { ConfigProvider } from '../../providers/config/config';
// import { Admob,AdMobEvent } from '@ionic-native/admob';
import { LidProvider } from '../../providers/lid-provider/lid-provider';
import { HttpClient } from '@angular/common/http';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { RequestProvider } from '../../providers/request/request';
import { Router } from '@angular/router';
// import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
declare var admob;
@Component({
    selector: 'test-page',
    templateUrl: 'test-page.html',
    styleUrls:['./test-page.scss']
})
export class TestPage{
    update: Subject<StatisticsResults> = null;
    @ViewChild('trophy')
    trophyComponent: TrophyComponent;

    treesCounter = {
        kilometer: "000",
        units: "000",
        trees: "000"
    };

    events = null;
    chart = {
        x: [],
        y: []
    };

    results = [{
        athleteId: 11785797,
        athleteName: "Maurice Clavel",
        cid: 295,
        commentCount: 1,
        eventDate: 1439078400000,
        eventId: 7592962,
        eventName: "Ironman 70.3 Germany",
        fanCount: 1,
        gplatz: 12,
        gtime: 15410,
        hasDatum: true,
        hasPlatz: true,
        hasStrecke: true,
        hasZeit: true,
        hitCount: 0,
        id: 7592975,
        lid: -1,
        picName: "https://spooorts.de/d/med/295/7592975/",
        resultText: "Platz 12 in 04:16:50 über 1,9-90-21,098km",
        strecke1: 1900,
        strecke2: 90000,
        strecke3: 21098,
        streckeconv: "1,9-90-21,098km",
        trophyColor: "1",
        trophyMaterial: "1",
        trophyType: "Pokal Gold"
    }];

    src = "https://spooorts.de/resources/images/title8.jpg";
    constructor(
        private router:Router,
        private translate: TranslateService,
        private eventService: EventProvider,
        private userService: UserProvider,
        private sessionService: SessionProvider,
        private sharingService:SharingProvider,
        private platform: Platform,
        private userProvider: UserProvider,
        // public admob:AdMob,
        // private admob: Admob,
    public http: HttpClient,
        // public splashScreen:SplashScreen
    ) {
        // splashScreen.hide()
        // this.platform.ready().then(async () => {
        //     const banner = new this.admob.banner({
        //       adUnitId: 'ca-app-pub-xxx/yyy',
        //     });
        //     await banner.show();
      
            // admob.on('admob.banner.impression').subscribe(async () => {
            //   await banner.hide();
            // });
          
    }
    ionViewDidEnter(){
        console.log('1')
        const bannerOptions = {
            id: {
                android:'ca-app-pub-3372584184973915/6010960498',
                ios:'ca-app-pub-3372584184973915/6010960498'},
            // autoShow: true,
            // isTesting: true,
            // bannerAtTop: false,
        };
        if(this.platform.is('ios')){
        this.platform.ready().then(async() => {
        // if(this.platform.is('cordova')){
            console.log('platform ready')
            // admob.setDevMode(true);
            // try {
            //     await admob.showBannerAd();
            // } catch (err) {
            //         console.log('Error showing/hiding banner: showBannerAd');
            //     }
        //    if(this.platform.is('ios')){
            console.log('ios')
                try{admob.setDevMode(true);}
                catch (err){
                    console.log('devmode', err)
                }
               try{
                admob.createBannerView(bannerOptions)
               } catch(err){
                console.log('err in create banner', err)
               }
               try{
                await admob.showBannerAd(true);
               } catch(err){
                console.log('err in showbanner', err)
               }
                // await admob.showBannerAd();
                admob.banner.show({
                    adId:'ca-app-pub-3372584184973915/6010960498',
                    // autoShow: true,
                    // isTesting: true,
                    // position: 'bottom', 
                    size: 'SMART_BANNER' 
                }).then(() => console.log('Banner ad loaded'))
                .catch(err => console.error('Error loading banner ad:', err));
                document.addEventListener('admob.banner.load', (e) => {
                    console.log( `Successfully showing ads...`, e);
                  });
                  document.addEventListener('admob.banner.load_fail', (e) => {
                    console.error(`Error showing ads...`, e);
                  });
        
        //    }
        //    else if(this.platform.is('android')){
        //         console.log('android')
        //         try{
        //             admob.setDevMode(true);
        //             // console.log(admob.createBanner(bannerOptions))
        //         }catch(err){
        //             console.log('devmode', err)
        //         }
        //         admob.banner.show({
        //             id:  'ca-app-pub-3372584184973915/6010960498',
        //            autoShow: true,
        //            isTesting: true,
        //            position: 'bottom', 
        //            size: 'SMART_BANNER', 
        //            overlap: true
        //        }).then(() => console.log('Banner ad loaded'))
        //        .catch(err => console.error('Error loading banner ad:', err));
        //        document.addEventListener('admob.banner.load', (e) => {
        //         console.log( `Successfully showing ads...`, e);
        //       });
          
        //       document.addEventListener('admob.banner.load_fail', (e) => {
        //         console.error(`Error showing ads...`, e);
        //       });
        //    }
            console.log('banner');
        })
    }
    }

    test() {
        const node = document.getElementById('blackSquare');
        domtoimage.toPng(node).then(image => {
            console.log(image);
            // this.sessionService.getToken(true, false).then(token => {
            let token = "be4aa99d86476b5fe8b4ecc2fb695bf601a95cc46cd9762cee9e8ce79b2bd26489b2078e70059bca44ab1f8113c7d1f5e0b17d619634820580db5fac22c39c6b";
            this.userService.uploadMyPhoto({
                id: -1,
                imageLink: image.split('base64,')[1],
                name: "pic" + new Date().getTime() + ".png"
            }, token).then(res => {
                alert(res);
            }).catch(err => {
                console.log(err);
            });
            // })
        });
    }

    onTestFab() {
        setTimeout(() => {
            this.results.push();
        }, 6000);
    }

    getTrainingsData() {
        this.eventService.getTrainings().then((trees: TreesCounter[]) => {
            if (!trees) return;
            this.treesCounter.kilometer = Math.floor(trees.reduce((acc, cur) => acc + cur.distMeterSum, 0) / 1000) + "";
            this.treesCounter.trees = Math.floor(Number(this.treesCounter.kilometer) / 50) + "";
        });
    }


    filterData() {
        for (let i = 0; i < this.events.length; i++) {
            if (typeof this.events[i].monthly === "undefined") {
                this.events.splice(i, 1);
            }
        }
    }

    convertData() {
        for (let i = 0; i < this.events.length; i++) {
            for (let j = 0; j < this.events[i].monthly.length; j++) {
                let date = this.shortcut(this.events[i].monthly[j].monthName) + " " + this.events[i].year;
                this.chart.x.push(date);

                let distance = Math.floor(this.events[i].monthly[j].monthDistance / 1000);
                this.chart.y.push(distance);
            }
        }
        this.chart.x = this.chart.x.reverse();
        this.chart.y = this.chart.y.reverse();
    }

    shortcut(month) {
        let shortcut = month;
        switch (month) {
            case "January": shortcut = "Jan"; break;
            case "February": shortcut = "Feb"; break;
            case "March": shortcut = "Mar"; break;
            case "April": shortcut = "Apr"; break;
            case "May": shortcut = "May"; break;
            case "June": shortcut = "Jun"; break;
            case "July": shortcut = "Jul"; break;
            case "August": shortcut = "Aug"; break;
            case "September": shortcut = "Sept"; break;
            case "October": shortcut = "Oct"; break;
            case "November": shortcut = "Nov"; break;
            case "December": shortcut = "Dec"; break;
        }

        return shortcut.toUpperCase();
    }

    configureChart() {
        const canvas = document.getElementById('myChart') as HTMLCanvasElement;
        const ctx = canvas.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 135);
        gradient.addColorStop(0, '#408a79');
        gradient.addColorStop(1, 'transparent');

        var data = {
            labels: this.chart.x,
            datasets: [
                {
                    label: '',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: gradient, //nothing changes
                    borderColor: "#28564b",
                    borderCapStyle: 'round',
                    borderDash: [],
                    borderDashOffset: 2.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: "#28564b",
                    pointBackgroundColor: "#fff",
                    pointBorderWidth: 3,
                    pointHoverRadius: 4,
                    pointRadius: 4,
                    pointHitRadius: 4,
                    data: this.chart.y
                }
            ]
        }


        var myLineChart = new Chart(ctx, {
            type: 'line',
            data: data,
            options: {
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            gridLines: {
                                color: function (value, index, values) {
                                    console.log('values: ', values);
                                    console.log('index: ', index);
                                    console.log('value: ', value);
                                    return value;
                                },
                            },
                            fontColor: 'black',
                            maxTicksLimit: 3,
                            callback: function (value, index, values) {
                                return value + ' km';
                            }
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            fontColor: 'black',
                            maxTicksLimit: 4,
                            // Include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                return value;
                            },
                        }
                    }]
                },
                legend: {
                    display: false
                }
            }
        });
    }
    // imageWidth: number = innerWidth - (innerWidth - (innerWidth * 0.9));
    // imageHeight: number = innerHeight - (innerHeight - (innerHeight * 0.65));
    // imageUrl = "assets/imgs/goforest/forest.jpg";
    canvasStats;
    resultDetails = {
        distance: "124 KM",
        time: "12:00:12",
        place: "1. Place",
        eventName: "Slaviks MArathon",
        eventDate: "12.03.2023"
    }

    applyResultsForFirstEventPicture() {
        return new Promise((resolve, reject) => {
            let resultDetails = {
                distance: "124 KM",
                time: "12:00:12",
                place: "1. Place",
                eventDate: "12.03.2023",
                eventName: "Slaviks MArathon",
                cid: "Running",
            }
            let images = [];
            if (!images.length) {
                images.push({
                    imageLink:  "https://spooorts.de/resources/images/title8.jpg"
                    // imageLink: 'https://images.unsplash.com/photo-1622894830890-ad564b5136ed?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fG1hbnV8ZW58MHx8MHx8fDA%3D'
                    // imageLink:"https://t4.ftcdn.net/jpg/02/91/24/27/360_F_291242770_z3XC7rJB1Mvc5jVMsEY9Dx2xMrX4sxUi.jpg"
                //    imageLink: 'https://images.unsplash.com/photo-1610715897403-6bd03a9002a9?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8d2FuZGVyaW5nfGVufDB8fDB8fHww'
                    // imageLink: 'https://media.istockphoto.com/id/1065044106/photo/one-young-female-hiker-walks-up-hill.webp?b=1&s=170667a&w=0&k=20&c=MTJW7QWeoqY7iS6lPQgwl4oHN8YCmgI4n5VLMShKtOY='
                    // imageLink: 'https://media.istockphoto.com/id/1058824356/photo/man-hiking-through-rough-and-rocky-mountain-trail.jpg?s=612x612&w=0&k=20&c=pQ-JurPSvu3hp_dAs7yaLf-jo-ZaLOxbmLHXHV6fD7w='
                    // imageLink: "https://images.unsplash.com/photo-1607992922515-7e38329e65d4?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bmF0dXJlJTIwaW1hZ2VzfGVufDB8fDB8fHww"
                });
            }
            console.log(images);
            const imageUrl = images[0].imageLink;
            let canvas = <HTMLCanvasElement>document.getElementById("myCanvas");
            let context = canvas.getContext("2d");

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.src = imageUrl;
            let that = this;
            img.onload = function (e) {
                canvas.height = img.height;
                console.log(img.height)
                console.log(img.width)
                canvas.width = img.width;
                context.drawImage(img, 0, 0, img.width, img.height);
                let canvasStats = <HTMLCanvasElement>document.getElementById("myCanvas");
                let contextStats = canvasStats.getContext("2d");
                let logo = new Image();

                logo.src = "assets/imgs/goforest/white.png";
                
                logo.onload = function () {

                    that.sharingService.generateImage(resultDetails, {
                        context, contextStats }, that, img, canvasStats, logo).then((image) => {
                        resolve (image)
                    })
                }
                context.fillStyle = 'rgba(0, 0, 0, 0.5)'; 
                context.fillRect(0, 0, img.width, img.height);
                context.restore();
                
            }
        });
    }
}




